import { theme } from '@mvf/product-components';
import { HudPresetContext } from '@mvf/product-components/contexts';
import { FunctionComponent, ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import { router, presets } from './Pages/router';
import { buildStore } from '@mvf/product-components/redux';
import { rootReducers, rootSagas } from './Global/Store';
import { context } from '@opentelemetry/api';

type ComponentType = FunctionComponent<{
  children: ReactNode;
}>;

export const bootstrap = (id: string): void => {
  const element = document.getElementById(id);

  if (element) {
    const store = buildStore(rootReducers, {
      options: {
        context: {
          trace: context.active(),
        },
      },
      generator: rootSagas,
    });
    const Setup: ComponentType = ({ children }) => (
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <HudPresetContext.Provider value={presets}>
            {children}
          </HudPresetContext.Provider>
        </ThemeProvider>
      </Provider>
    );

    const root = createRoot(element);
    root.render(
      <Setup>
        <RouterProvider router={router} />
      </Setup>,
    );
  }
};
